module.exports = __webpack_public_path__ + "assets/StarLMovesIcon.c429d93810c6102397731a81491817a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/stars/StarLMovesIcon.svg
// module id = 92
// module chunks = 0